var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.984 4.487L10.614.16a.56.56 0 00-.393-.16H2.575C1.672 0 .937.699.937 1.558v14.884c0 .86.735 1.558 1.638 1.558h10.923c.903 0 1.638-.699 1.638-1.558V4.846a.506.506 0 00-.152-.36zm-.94 11.955c0 .287-.245.52-.546.52H2.575a.534.534 0 01-.546-.52V1.558c0-.287.245-.52.546-.52h7.413l4.056 4.017v11.387z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.398 12.388a.566.566 0 00-.772 0 .501.501 0 000 .735l2.317 2.202c.213.203.559.203.772 0l2.317-2.202a.501.501 0 000-.735.566.566 0 00-.772 0l-1.93 1.836-1.932-1.836z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.914 9.52A.533.533 0 008.367 9a.533.533 0 00-.546.52v3.115c0 .286.245.519.546.519l.547-.52V9.52z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.914 12.635c0 .286-.245.519-.547.519a.533.533 0 01-.546-.52V9.52c0-.287.245-.519.546-.519l.547.52v3.115zM9.675 2.77a.533.533 0 00-.546-.52.533.533 0 00-.546.52v3.115c0 .286.244.519.546.519h3.276a.533.533 0 00.546-.52.533.533 0 00-.546-.519h-2.73V2.77z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.1446ade6.svg";
export { ForwardRef as ReactComponent };